const producao = 'https://apidesk-sugep.dixiponto.com.br';
const local = 'http://localhost:8080';

// Manter como "producao" na main
const API_BASE_URL = producao;

export default API_BASE_URL;